// @generated by TypeGen from LogbookModel/Note.swift - DO NOT EDIT

import type { ILogbookModel } from "./Model"
import type { INoteAttachment } from "./NoteAttachment"

export interface INote extends ILogbookModel {
  id: number;
  cruiseId?: number;
  tripId?: number;
  dayId?: number;
  logId?: number;
  accountId: number;
  shipId: number;
  userId?: number;
  createdAt: string;
  updatedAt: string;
  syncedAt?: string;
  deletedAt?: string;
  data: string;
  date?: string;
  note?: string;
  noteExtra?: string;
  noteType: INoteType;
  sortOrder?: number;
  title?: string;
  attachments?: INoteAttachment[];
}

export interface INoteData {
}

export interface INoteResponse {
  note?: INote;
}

export interface INotesResponse {
  notes: INote[];
}

export enum INoteType {
  journal = 1,
  technical = 2,
  weather = 3,
  watchplan = 4,
  crew = 10,
  watch = 11,
  planning = 20,
}

export type INoteParsed = Omit<INote, "data"> & { dataParsed: INoteData };

export const Note = {
  parse(r: INote): INoteParsed {
    return { ...r, dataParsed: r.data != null ? JSON.parse(r.data) : {} } as INoteParsed;
  },
};
